import { ScrollDownButton } from '@radix-ui/react-select';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { Icon } from '@/shared/ui/icon';
import './select.scss';

type Props = ComponentPropsWithoutRef<typeof ScrollDownButton>;
export const SelectScrollDownButton = ({ className, ...props }: Props) => {
    return (
        <ScrollDownButton
            data-testid="select-scroll-down-button"
            className={cn('select__scroll-button', 'select__scroll-button--down', className)}
            {...props}
        >
            <Icon name="chevron-right" />
        </ScrollDownButton>
    );
};
